import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './Reveal';
type FAQItem = {
  question: string;
  answer: string;
};
const faqs: FAQItem[] = [{
  question: 'Comment fonctionne le système ?',
  answer: 'Le système combine 6 tomes thérapeutiques illustrés et 5 bonus cliniques pour vous guider à travers le travail complet des Constellations Familiales — des lois systémiques fondamentales jusqu’à l’intégration finale et l’écriture d’un nouveau récit de vie.'
}, {
  question: 'Ai-je besoin de connaissances préalables ?',
  answer: 'Non. Le système a été conçu pour être accessible aux débutants complets tout en étant suffisamment profond et cliniquement rigoureux pour les praticiens expérimentés.'
}, {
  question: 'Les ressources sont-elles vraiment imprimables ?',
  answer: 'Oui. Toutes les ressources — cartes de constellation, phrases de guérison, modèles de génogramme et fiches de travail — sont formatées en haute résolution pour une impression A4 parfaite.'
}, {
  question: 'Les 5 Bonus sont-ils vraiment gratuits ?',
  answer: 'Oui. Les 5 Bonus Cliniques d’une valeur totale de 75 EUR sont inclus gratuitement avec votre achat de 19 EUR — sans condition ni abonnement.'
}, {
  question: 'Combien de temps ai-je accès au contenu ?',
  answer: 'Accès à vie. Vous téléchargez tous les fichiers immédiatement après l’achat et vous les possédez pour toujours. Aucun abonnement. Aucune limite de temps. Aucun frais récurrent.'
}, {
  question: 'Qu’est-ce qui rend ce système différent des ressources gratuites en ligne ?',
  answer: 'Les ressources gratuites offrent des fragments. Ce système offre une architecture clinique complète — 6 tomes qui se construisent l’un sur l’autre dans un ordre thérapeutique précis, avec des protocoles pas à pas et des ressources imprimables professionnelles prêtes à utiliser en séance.'
}, {
  question: 'Et si cela ne fonctionne pas pour moi ?',
  answer: 'Garantie complète de remboursement 7 jours. Téléchargez tout, travaillez le contenu, utilisez les ressources. Si vous ne ressentez pas un changement profond dans les 7 jours — remboursement intégral, sans question, sans formulaire.'
}];
function Item({
  item,
  index
}: {
  item: FAQItem;
  index: number;
}) {
  const [open, setOpen] = useState(false);
  return <Reveal delay={index * 0.035} data-id="element-56" data-mp="38j53kxxuaw5w">
      <div className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-premium" data-id="element-57" data-mp="33lwm6zkimw5p">
        <button className="flex w-full items-center gap-4 p-5 text-left sm:p-6" onClick={() => setOpen(!open)} aria-expanded={open} data-id="element-58" data-mp="2yms8pwqk6c9k">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-sage text-sm font-bold text-white" data-id="element-59" data-mp="1n86dffigbjpq">
            ?
          </span>
          <span className="flex-1 font-semibold text-navy" data-id="element-60" data-mp="1j4zyzkl6qm86">{item.question}</span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sage transition-transform duration-200 ${open ? 'rotate-180' : ''}`} data-id="element-61" data-mp="3uuxzqh96upq8" />
        </button>
        <AnimatePresence initial={false} data-id="element-62" data-mp="7pgstw87s008">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: 'easeOut'
        }} data-id="element-63" data-mp="7n42auoe4hbk">
              <p className="px-5 pb-6 pl-16 text-sm leading-7 text-slate sm:px-6 sm:pl-[4.5rem]" data-id="element-64" data-mp="mdbnvj9p2ggh">{item.answer}</p>
            </motion.div>}
        </AnimatePresence>
      </div>
    </Reveal>;
}
export function FAQ() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-65" data-mp="ve014br9kcsb">
      <div className="mx-auto max-w-3xl" data-id="element-66" data-mp="2s84mavsfq8l0">
        <Reveal className="text-center" data-id="element-67" data-mp="2s95zp6wxb75w">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-68" data-mp="2x5mlvvkkbbgc">
            ❓ Questions <span className="text-sage" data-id="element-69" data-mp="21vps79o8pehi">fréquentes</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-70" data-mp="21y2kogrmj78t">Tout ce que vous devez savoir avant d’acheter.</p>
        </Reveal>
        <div className="mt-10 space-y-3" data-id="element-71" data-mp="1wz94uhov745h">
          {faqs.map((faq, index) => <Item key={faq.question} item={faq} index={index} data-id="element-72" data-mp="2btdymwv7kafi" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}